import React from "react";
import { Link } from "react-router-dom";
import useFleetStore from "../../stores/useFleetStore";

const FlagBoard = ({ shopDisplay }) => {
  const flags = useFleetStore((state) => state.flags);

  const renderFlagBoard = () => {
    if (flags.length === 0) {
      return (
        <div className="bg-[#242424] rounded p-3 text-center text-on-surface-variant text-sm">
          No drones need service :)
        </div>
      );
    }

    return (
      <div className="rounded overflow-hidden border border-primary">
        <div className="px-3 py-2 border-b border-black/30 flex items-center justify-between">
          <span className="text-xs text-on-surface-variant uppercase tracking-wide">Needs Attention</span>
          <span className="text-primary font-bold text-sm">{flags.length}</span>
        </div>
        <ul className="FlagBoard">
          {flags.map((flag) => (
            <li key={flag.dateflagged} className="FlagBoard_li hover:bg-primary/10 transition-colors">
              <Link to={`/drone/${flag.drone_serial}`} className="flex items-center gap-2 px-3 py-1">
                <span className="text-primary font-mono font-bold text-sm">
                  {(flag.drone_serial).slice(-6)}
                </span>
                <span className="text-on-surface text-sm truncate">
                  {flag.descript}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return <>{renderFlagBoard()}</>;
};

export default FlagBoard;
